import { render } from "./ForumCategory.vue?vue&type=template&id=6b1b03bf&scoped=true"
import script from "./ForumCategory.vue?vue&type=script&lang=js"
export * from "./ForumCategory.vue?vue&type=script&lang=js"

import "./ForumCategory.vue?vue&type=style&index=0&id=6b1b03bf&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1b03bf"]])

export default __exports__